/**
 * One `RouteObject`, so the file is `server-error.route.tsx` (singular).
 *
 * Eager for the same two reasons as its sibling: the code-split policy names
 * no system chunk, and a page that explains a failure must not depend on
 * fetching a chunk over whatever produced the failure.
 *
 * The route entry passes no reason and no correlation id, because a reader who
 * navigated here directly has no failing request behind them. The root error
 * boundary is the caller that has both.
 */
import type { RouteObject } from 'react-router-dom';

import { ServerErrorPage } from './ServerErrorPage';

export const serverErrorRoute: RouteObject = {
  path: '500',
  element: <ServerErrorPage />,
};
